<template>
  <div class="card-selector mt-2 mt-md-5 mb-2">
    <p class="label mb-1">{{ store.content.label_card_select }}</p>

    <div class="dropdown">
      <button
        class="dropdown-toggle w-100 mt-0-5"
        type="button"
        id="card-select-btn"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center mr-1">
            <img :src="store.selectedCard.img_src" alt="">
            <p class="title" v-html="store.selectedCard.title"></p>
          </div>
          <img src="" :data-src="`${store.baseUrl}/images/icon_caret-down.png`" class="arrow lazy" alt="">
        </div>
      </button>
      <div class="dropdown-menu w-100" aria-labelledby="card-select-btn">
        <button
          class="option d-flex justify-content-between align-items-center w-100"
          v-for="(card, index) in selectableCards"
          :key="index"
          @click="selectCard($event)"
          @keydown.enter="selectCard($event)">
          <div class="d-flex align-items-center">
            <img :src="card.img_src" alt="">
            <p class="title" v-html="card.title"></p>
          </div>
        </button>
      </div>
    </div>
  </div>
  <p>Not a Marriott Bonvoy<sup>®</sup> American Express<sup>®</sup> Card Member?</p>
  <a :href="store.selectedCard.hero_cta_href" class="link-arrow text-white mt-1" target="_blank">Explore cards</a>
</template>

<script setup>
import { computed, nextTick } from 'vue';
import { useStore } from '../store';
import { q } from '../utilities';

const store = useStore();
const cards = content.cards;

const selectableCards = computed(() => cards.filter(card => card.title !== store.selectedCard.title));

function selectCard(e) {
  cards.map((card, i) => {
    if (card.title === e.target.querySelector('.title').innerHTML) {
      store.selectedCard = card;
      store.selectedTier = card.calculator.tiers[0];
      store.totalPoints = 0;
      history.pushState({}, '', card.url_path);
      document.title = store.selectedCard.page_title;
      q('meta[name="description"]').setAttribute('content', store.selectedCard.page_description);
      q('meta[name="twitter:title"]').setAttribute('content', store.selectedCard.social_title);
      q('meta[property="og:title"]').setAttribute('content', store.selectedCard.social_title);
      q('meta[property="og:url"]').setAttribute('content', window.location.href);
    }
  });
  nextTick(() => {
    q('.earning-calculator input[type="text"]').map(el => {
      el.value = 0;
      el.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });
  updateLabelWidths();
}

let widestLabelWidth = 0;

function updateLabelWidths() {
  q('.earning-calculator .value-label').map(el => {
    el.style.width = 'auto';
    widestLabelWidth = 0;
  });
  nextTick(() => {
    q('.earning-calculator .value-label').map(el => {
      const elWidth = Math.ceil(el.getBoundingClientRect().width);
      if (elWidth > 0 && elWidth > widestLabelWidth) {
        widestLabelWidth = elWidth;
      }
    });
    q('.earning-calculator .value-label').map(el => {
      el.style.width = widestLabelWidth + 'px';
    });
  });
}
</script>
